import "./home_view.css";
import ContactButton from "../../../core/components/buttons/contact_button/contact_button.jsx";
import { homeMapper } from "../utils/mapper/home_mapper.jsx";

const HomeView = () => {
    const { title, subtitle } = homeMapper;
    return (
        <div className="home">
            <div className="container">
                <div className="col-6 home_info">
                    <div>
                        <h1>{title}</h1>
                    </div>
                    <div>
                        <h2>{subtitle}</h2>
                    </div>
                    <div className="button_contact">
                        <ContactButton />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HomeView;
